import style from './basic_button.module.css';

const BasicButton = (
  param: {
    name: string;
    color?: string;
    height?: string;
    width?: string;
    func?: () => void,
    [key: string]: any;
  } = {
      name: "로그인",
      color: "C1BCC1",
      height: "25px",
      width: "100px",
    },
) => {
  const { name, color, background, padding, height, width, func, ...props } = param;

  return (
    <>
      <button onClick={func ? () => func() : () => console.log('NO FUNCTION')} className={style.basic_button} style={{ color, background, height, width, padding }} {...props}>{name}</button>
    </>
  );
};

export default BasicButton;
